import { useInfiniteQuery } from '@tanstack/react-query';
import { API_BASE } from './api-base';
import { apiFetch } from './api-client';
import { queryKeys } from './query-client';
import type { WebWin, WinsPageDto } from './wins';

async function fetchWinsPage(cursor?: string): Promise<WinsPageDto> {
  const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
  const res = await apiFetch(`${API_BASE}/api/wins${query}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return (await res.json()) as WinsPageDto;
}

export function useWins(): {
  wins: WebWin[];
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
  hasMore: boolean;
  loadingMore: boolean;
  loadMore: () => void;
} {
  const query = useInfiniteQuery({
    queryKey: queryKeys.wins,
    queryFn: ({ pageParam }: { pageParam?: string }) => fetchWinsPage(pageParam),
    getNextPageParam: (last: WinsPageDto) => last.nextCursor,
  });
  const seen = new Set<string>();
  const wins = (query.data?.pages ?? []).flatMap((p) => p.wins).filter((w) => (seen.has(w.id) ? false : (seen.add(w.id), true)));
  return {
    wins,
    isLoading: query.isLoading,
    isError: query.isError && !query.data,
    refetch: () => void query.refetch(),
    hasMore: !!query.hasNextPage,
    loadingMore: query.isFetchingNextPage,
    loadMore: () => void query.fetchNextPage(),
  };
}
